import React, { /*useState, useEffect,*/ useMemo } from "react";
import ThreeDotsLoader from "@components/loader/Loading";
import BalanceEmployeeBank from "./BalanceEmployeeBank";
import { useTranslation } from "react-i18next";
import { useReduxSelector } from "@hooks/useReduxSelector";
import { extractNumberFromStr } from "@helpers/_functions";

function EmployeeBankInfo({ /*employeeBanks = [],*/ hoursPerDay, selectedEmployee }) {
  const { t: mainTranslator, i18n } = useTranslation("pages.employés.emploi&Salary");

  const holidayList = useReduxSelector(
    ({ settings }) => settings.holidayName?.list || []
  );

  const employeeNethrisSoldes = useReduxSelector(({ enterpriseEmployeData }) => enterpriseEmployeData.employeeNethrisSoldes);

  const bankNethris = useMemo(() => {
    const nethrisHolidays = holidayList
      ?.filter((holiday) => holiday.nethris && !holiday.desactivated && holiday.CombinedEmployees.includes(selectedEmployee))
      .map((holiday) => {
        const foundBank = employeeNethrisSoldes.data?.length
          ? employeeNethrisSoldes.data?.find(
            (bank) => bank.ABSENCE_CODE === extractNumberFromStr(holiday.referenceCode)
          ) || {}
          : {};
        return { ...foundBank, ...holiday };
      });
    return nethrisHolidays || [];
  }, [employeeNethrisSoldes.data, holidayList]);

  return (
    <div className="arh-pb-[1rem] arh-mb-[2rem] arh-w-full arh-mt-[1rem] arh-border-x-0 arh-border-t-0 arh-border-b arh-border-solid arh-border-b-borderTable">
      <h6 className="arh-flex arh-items-center  arh-text-darkColor arh-font-poppins arh-font-bold arh-text-[0.938rem] arh-m-0 arh-mb-[2.5rem]">
        {mainTranslator("Information provenant du système de paie")}
      </h6>
      {
        employeeNethrisSoldes?.isLoading ?
          <div className="arh-w-full arh-flex arh-justify-center arh-items-center">
            <ThreeDotsLoader
              class="inherit_from_parent"
              color="#73C7B7"
              height="100"
              width="100"
            />
          </div>
          : 
          bankNethris?.map((bank) => (
            <BalanceEmployeeBank
              key={bank._id}
              employeebank={bank}
              hoursPerDay={hoursPerDay}
              labelTolltip={Boolean(i18n.language === "fr" ? bank?.informationFr : bank?.informationEn)}
              Title={(i18n.language === "fr" ? bank.informationFr : bank.informationEn)}
            />
          ))
      }
      {/* <BalanceEmployeeBank key={employeeBankVacancy.ABSENCE_TYPE} employeebank={employeeBankVacancy} />
      <BalanceEmployeeBank key={employeeBankSickness.ABSENCE_TYPE} employeebank={employeeBankSickness} /> */}
    </div>
  );
}

export default EmployeeBankInfo;
